import { ref, Ref, UnwrapRef } from "@vue/composition-api";

interface HistoryState<T> {
  past: T[];
  current: T;
  future: T[];
}

export interface HistoryManager<T extends object> {
  state: HistoryState<T> extends Ref
    ? HistoryState<T>
    : Ref<UnwrapRef<HistoryState<T>>>;

  undo(): void;

  redo(): void;

  push(newState: T): void;

  reset(newState: T): void;
}

export const makeHistory = <T extends object>(
  initial: T
): HistoryManager<T> => {
  const state = ref<HistoryState<T>>({
    past: [],
    current: initial,
    future: []
  });

  return {
    state,
    undo() {
      state.value = {
        past: state.value.past.slice(0, state.value.past.length - 1),
        current: state.value.past[state.value.past.length - 1] as any,
        future: [state.value.current as any, ...state.value.future]
      };
    },
    redo() {
      state.value = {
        past: [...state.value.past, state.value.current] as any,
        current: state.value.future[0] as any,
        future: state.value.future.slice(1)
      };
    },
    push(newState: T) {
      state.value = {
        past: [...state.value.past, state.value.current] as any,
        current: newState as any,
        future: []
      };
    },
    reset(newState: T) {
      state.value = {
        past: [],
        current: newState as any,
        future: []
      };
    }
  };
};
